import ClientModule from "@gqlapp/module-client-react";
import ViewRoute from "@modules/article/containers/view";
import ListRoute from "@modules/article/containers/list";
export default new ClientModule(ViewRoute, ListRoute);
